import { fetchStore } from '@/components/Navigation/MiniCart/order-queries'

let isDataInitialized = false
let isFetchingData = false

export default {
  namespaced: true,
  state: {
    currency: {},
    shipping: {
      cost: 0,
      treshold: 0,
    },
    customerServiceEmail: '',
    customerServicePhone: '',
  },
  mutations: {
    setState(state, payload) {
      for (const key in payload) {
        state[key] = payload[key]
      }
    },
  },
  actions: {
    fetchData({ commit }) {
      if (isDataInitialized || isFetchingData) return

      isFetchingData = true
      fetchStore()
        .then(({ currentStore }) => {
          commit('setState', currentStore)
          isDataInitialized = true
        })
        .finally(() => {
          isFetchingData = false
        })
    },
  },

  getters: {
    currency: state => state.currency,
    shippingCost: state => state.shipping.cost,
    shippingThreshold: state => state.shipping.threshold,
    customerServiceEmail: state => state.customerServiceEmail,
    customerServicePhone: state => state.customerServicePhone,
  },
}
